const inputs = () => {
    const date = document.querySelector('input[type=date]'),
          time = document.querySelector('input[type=time]'),
          select = document.querySelector('.overlay__select select'),
          newOptions = document.querySelectorAll('.overlay__select-li'),
          buttons = document.querySelectorAll('.overlay__overview-btn');

    date.addEventListener('input', () => {
        date.classList.remove('hide');
        try {document.querySelector('.overlay__data-label span').remove();} catch(e) {}
    });

    time.addEventListener('input', () => {
        try {document.querySelector('#time').remove();} catch(e) {}
    });

    document.querySelector('.overlay__select span').addEventListener('click', () => {
        document.querySelector('.overlay__select span').remove();
        select.click();
    });

    select.addEventListener('click', (e) => {
        if (window.getComputedStyle(select).display === 'block') {
            select.style.display = 'none';
            document.querySelector('.overlay__select-header').style.display = 'block';
            document.querySelector('.overlay__select-menu').style.display = 'block';
        }
    });

    newOptions.forEach( (option,i) => {
        option.addEventListener('click', function(e) {
            document.querySelector('.overlay__select-header').style.display = 'none';
            document.querySelector('.overlay__select-menu').style.display = 'none';
            select.style.display = 'block';
            select.querySelectorAll('option').forEach( (opt,j) => {
                opt.removeAttribute('selected');
                if(i === j) {
                    opt.setAttribute('selected','selected');
                }
            });
        });
    });
    window.addEventListener('click', (e) => {
        if (window.getComputedStyle(select).display !== 'block' && e.target.nodeName !== 'SELECT' && e.target.nodeName !== 'SPAN') {
            document.querySelector('.overlay__select-header').style.display = 'none';
            document.querySelector('.overlay__select-menu').style.display = 'none';
            select.style.display = 'block';
        }
    });

    buttons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            const x = e.clientX;
            const y = e.clientY;

            const buttonTop = e.target.offsetTop;
            const buttonLeft = e.target.offsetLeft;

            const xInside = x - buttonLeft;
            const yInside = y - buttonTop;

            const circle = document.createElement('span');
            circle.classList.add('circle');
            circle.style.top = (yInside - 76) + 'px';
            circle.style.left = (xInside - 290) + 'px';

            this.appendChild(circle);

            setTimeout(() => circle.remove(), 500);
        });
    });
};

export default inputs;